import { FormControl, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { FieldPath, FieldValues, UseControllerProps } from 'react-hook-form';

const EmailInput = <
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
    ...props
}: UseControllerProps<TFieldValues, TName>) => {
    return (
        <FormField
            control={props.control}
            name={props.name}
            render={({ field }) => (
                <FormItem className="col-span-2 md:col-span-1">
                    <FormLabel required>Adres email</FormLabel>
                    <FormControl>
                        <Input
                            type="email"
                            autoComplete="email"
                            placeholder="jan.kowalski@email.com"
                            {...field}
                        />
                    </FormControl>
                </FormItem>
            )}
        />
    );
};

export default EmailInput;
